import { bscTestnet, baseGoerli, polygonMumbai } from "wagmi/chains";

export const SUPPORT_CHAINS = [bscTestnet, baseGoerli, polygonMumbai];

export const NFT_PRICE = '0.03';

export const NFT_CONTRACT = {
  [bscTestnet.chainId]: "0x806C199C6217D9a281a292690ce09c2390d7c3D1",
  [baseGoerli.chainId]: "0x806C199C6217D9a281a292690ce09c2390d7c3D1",
  [polygonMumbai.chainId]: "0x806C199C6217D9a281a292690ce09c2390d7c3D1",
};
